<lib-page-layout>
  <lib-title-navbar
    pageHeader
    extended
    [interceptBack]="true"
    (actionOnBack)="cancel()"
    title="Mój profil"></lib-title-navbar>

  <div pageHeader class="or-d-flex or-justify-content-center z-index-999 negative-top-margin-35-px">
    @if (userData(); as user) {
      <div class="or-position-relative">
        @if (!base64image().isAvailable) {
          <lib-or-avatar
            [avatarUrl]="user.avatarUrl"
            [avatarSize]="'lg'"
            [initials]="user.displayName"
            [rightMargin]="false"
            [priority]="true">
          </lib-or-avatar>
        } @else {
          <lib-or-avatar
            [base64]="base64image().base64"
            [avatarSize]="'lg'"
            [rightMargin]="false"
            [priority]="true"></lib-or-avatar>
        }
        @if (!isHidden()) {
          <or-icon
            (click)="changeAvatar()"
            name="camera"
            size="xs"
            class="avatar-edit-icon or-cursor-pointer or-bg-main-1 or-color-white" />
        }
      </div>
    }
  </div>

  @if (userData(); as user) {
    <div pageHeader class="or-d-flex or-flex-col or-align-items-center or-mt-12-px or-mb-4-px">
      <div class="or-head-lg">{{ user.name }} {{ user.surname }}</div>
      <div class="or-text-sm or-color-secondary-2">{{ user.email }}</div>
    </div>
  }

  @if (userData(); as user) {
    <div class="edit-profile-container">
      <form [formGroup]="profileForm" class="or-d-flex or-flex-col or-justify-content-center or-mx-24-px or-mt-24-px">
        <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Imie <span class="or-color-red">*</span></div>
        <input
          class="outline-none input-style or-mb-12-px"
          formControlName="name"
          [ngClass]="{ 'error-field': isFieldInvalid('name') }"
          [maxlength]="15" />
        @if (isNameOverAvailableLength()) {
          <div class="or-mb-12-px or-text-sm or-color-red or-mt-2-px">Maksymalna długość to 15 znaków</div>
        }

        <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Nazwisko</div>
        <input class="outline-none input-style or-mb-12-px" formControlName="lastName" [maxlength]="15" />
        @if (isLastNameOverAvailableLength()) {
          <div class="or-mb-12-px or-text-sm or-color-red or-mt-2-px">Maksymalna długość to 15 znaków</div>
        }

        <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Telefon</div>
        <div class="or-d-flex or-align-items-center">
          <div class="phone-input-prefix or-align-content-center or-align-items-center">+48</div>
          <input
            class="outline-none phone-input or-w-100-pc"
            formControlName="phone"
            type="text"
            inputmode="numeric"
            [maxlength]="9" />
        </div>

        <div class="or-head-xs or-mt-32-px or-mb-16-px">Informacje dodatkowe</div>

        <div class="or-d-flex or-justify-content-center preferences-fields">
          <div class="or-d-flex or-flex-col or-w-100-pc or-mr-12-px">
            <div class="or-head-xs or-color-secondary-2 text-no-wrap or-mb-2-px">Preferowana pozycja</div>
            <input
              (click)="openPositionModal()"
              class="input-style outline-none or-cursor-pointer"
              readonly
              [value]="preferredPositionLabel" />
          </div>

          <div class="or-d-flex or-flex-col or-w-100-pc">
            <div class="or-head-xs or-color-secondary-2 or-mb-2-px">Twój poziom</div>
            <input
              (click)="openLevelModal()"
              class="input-style outline-none or-cursor-pointer"
              readonly
              [value]="preferredLevelLabel" />
          </div>
        </div>

        <!--
        @if (user.canSetReferral) {
          <div class="or-head-xs or-color-secondary-2 or-mb-4-px or-mt-20-px">Kod polecającego</div>
          <input class="outline-none input-style or-mb-12-px" formControlName="referrerToken" />
        }
        -->
      </form>

      <div
        (click)="openRemoveAccountModal()"
        class="or-d-flex or-justify-content-center or-mt-28-px or-text-decoration-underline or-text-md or-w-100-pc">
        Usuń konto
      </div>
    </div>
  }

  <lib-page-actions pageActions>
    <button (click)="cancel()" class="button-secondary-style or-h-48-px or-w-100-pc or-head-md">Anuluj</button>
    <button
      [disabled]="!profileForm.valid"
      (click)="saveData()"
      class="button-primary-style or-color-white or-h-48-px or-w-100-pc or-head-md"
      [ngClass]="{ 'disabled-button': !profileForm.valid }">
      Zapisz zmiany
    </button>
  </lib-page-actions>
</lib-page-layout>
